import { Spine } from "pixi-spine";
import { FullScreenFade } from "../../../../common/components/FullScreenFade";
import { PromiseCompletionSource } from "scene-manager";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { Container, IDestroyOptions } from "pixi.js";
import { SpineResourcesPackage } from "../../../../common/resources/SpineResourcesPackage";
import { AdaptiveView } from "../../../../common/views/AdaptiveView";

export class ForceRotateView extends AdaptiveView<void> {
    private fade: FullScreenFade;
    private animation: Spine;
    private parentLink: Container;

    constructor(
        private readonly spineResources: SpineResourcesPackage,
        protected readonly canvasScaler: ICanvasScaler, 
        pcs: PromiseCompletionSource<void>) {
        super(canvasScaler, pcs);
        this.build();
        this.layout(this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight, true);
        this.cursor = "hover";
        this.handleOrientationChange = this.handleOrientationChange.bind(this);
        window.addEventListener("orientationchange", this.handleOrientationChange);
        window.addEventListener("resize", this.handleOrientationChange);
    }

    private build(): void {
        this.fade = new FullScreenFade(this.canvasScaler, 0.8);
        this.frame = new Container();
        this.animation = new Spine((this.spineResources.assets_spine_rotate_rotate_screen_animation_json as any).spineData);
        this.animation.state.setAnimation(0, "mainAnimation", true);
        this.frame.addChild(this.animation);
        this.addChild(this.fade, this.frame);
    }

    protected layout(width: number, height: number, _initialLayout: boolean): void {
        this.frame.position.set((width - this.frame.width)* 0.5, (height - this.frame.height)* 0.5);
    }

    private handleOrientationChange() {
        requestAnimationFrame(() => {
            window.isPortrait() && this.operationControls.complete();
        });
    }

    public start(): void {
        if (this.parent) {
            this.parent.on("childAdded", this.surface, this);
            this.parentLink = this.parent;
        }
    }

    private surface(): void {
        this.parent.setChildIndex(this, this.parent.children.length - 1);
    }


    public override destroy(options?: IDestroyOptions | boolean): void {
        this.parentLink.off("childAdded", this.surface, this);
        window.removeEventListener("orientationchange", this.handleOrientationChange);
        window.removeEventListener("resize", this.handleOrientationChange);
        super.destroy(options);
    }

}
